<div class="container">
    <div class="tw-text-center tw-font-extrabold tw-text-xl md:tw-text-3xl tw-pb-8 tw-px-4">Benefits For Employer and
        Employee
    </div>
    <!-- employer benefits -->
    <h2 class="employee-benefits tw-font-extrabold tw-text-lg md:tw-text-xl tw-text-left tw-mb-6 tw-text-left ">
        Employer Benefits :
    </h2>
    <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 md:tw-gap-8 employee-benefits-box">
        <div class="tw-flex tw-justify-left tw-px-4 tw-border-[1px] tw-bg-white tw-shadow tw-rounded tw-border-yellow"
            *ngFor="let employer of employerBenefits">
            <img src="/assets/images/corporate/{{employer.icon}}" alt="{{employer.label}}">
            <p class="tw-text-xs">{{employer.label}}</p>
        </div>
    </div>

    <!-- employee benefits -->
    <h2 class="employee-benefits tw-font-extrabold tw-text-lg md:tw-text-xl tw-mt-16 tw-mb-6 tw-text-left md:tw-mt-12">
        Employee Benefits :
    </h2>
    <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 md:tw-gap-8 employee-benefits-box">
        <div class="tw-flex tw-justify-left tw-px-4 tw-border-[1px] tw-bg-white tw-shadow tw-rounded  tw-border-yellow"
            *ngFor="let employee of employeeBenefits">
            <img src="/assets/images/corporate/{{employee.icon}}" alt="{{employee.label}}">
            <p class="tw-text-xs">{{employee.label}}</p>
        </div>
    </div>
</div>